<div class="overlay" *ngIf="showRelevance">
  <hero-relevance
    [relevance]="topic.relevance || null"
    (close)="closeRelevance()"
    (save)="saveRelevance($event)"
    [sectionTitle]="sectionTitle"
    [topicTitle]="topic.topic_title"
    [topicDescription]="topic.topic_description||''"
    [readOnly]="readOnly"
  ></hero-relevance>
</div>

<div class="overlay" *ngIf="showComment">
  <hero-comment
    [comment]="topic.topic_comment || null"
    (close)="closeComment()"
    (save)="saveComment($event)"
    [sectionTitle]="sectionTitle"
    [topicTitle]="topic.topic_title"
    [topicDescription]="topic.topic_description||''"
    [readOnly]="readOnly"
    [otherComments]="topic.other_comments || []"
  ></hero-comment>
</div>

<div class="topic d-flex flex-row">
  <div class="feedbacker" *ngIf="feedbacker">
    <div class="feedbacker-1 pointer" (click)="toogleFeedbacker(0)">
      <i *ngIf="!feedback1 && !requireFeedbacker[0]" class="fa fa-circle-o" aria-hidden="true"></i>
      <i *ngIf="!feedback1 && requireFeedbacker[0]" class="fa fa-check-circle-o" aria-hidden="true"></i>
      <i *ngIf="feedback1 && requireFeedbacker[0]" class="fa fa-check-circle" aria-hidden="true"></i>
    </div>
    <div class="feedbacker-2 pointer" (click)="toogleFeedbacker(1)">
      <i *ngIf="!feedback2 && !requireFeedbacker[1]" class="fa fa-circle-o" aria-hidden="true"></i>
      <i *ngIf="!feedback2 && requireFeedbacker[1]" class="fa fa-check-circle-o" aria-hidden="true"></i>
      <i *ngIf="feedback2 && requireFeedbacker[1]" class="fa fa-check-circle" aria-hidden="true"></i>
    </div>
  </div>
  <div class="description">
    <div (click)="!preview && openRelevance()"
         class="header d-flex justify-content-between"
         [ngClass]="topic.relevance?.type"
         [class.preview]="preview"
         [class.pointer]="!preview"
    >
      <span>{{topic.topic_title}}</span>
      <span *ngIf="topic.relevance?.type==RelevanceType.Strength">My Strength</span>
      <span *ngIf="topic.relevance?.type==RelevanceType.Development">For Development</span>
      <span *ngIf="topic.relevance?.type==RelevanceType.NotImportant">Not Relevant</span>
      <span *ngIf="topic.relevance?.type==RelevanceType.Achieved">Achieved</span>
    </div>
    <div class="body">
      {{topic.topic_description}}
    </div>
  </div>
  <div class="slider">
    <hero-slider
      [max]="5"
      [values]="[0]"
      [thumbImages]="['/assets/thumb_3.png']"
      [readOnly]="readOnly || preview"></hero-slider>
  </div>
  <div class="actions">
    <button *ngIf="!preview"
            class="btn btn-hero btn-hero-icon"
            (click)="openComment()"
    ><i class="fa fa-comment-o" aria-hidden="true"></i></button>
  </div>
</div>
